import GrumpyMap from "../components/GrumpyMap";

const WarMap = () => {
  return <GrumpyMap />;
};

export default WarMap;
